// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__AvnY7","active":"Navigation_active__r3kuj","spin":"Navigation_spin___m0D_","loader":"Navigation_loader__km5KL"};